export class RouterCore {

  constructor(router, appModel, authCore, store ) {
    this.router = router
    this.appModel = appModel
    this.authCore = authCore
    this.store = store
  }
  get appModule() {
    return this.appModel.Modules.DefaultModuleImpl
  }
  get userPages()  {
    let pages = []
    for (let moduleIndex in this.appModel.UserModel.Modules) {
      if (this.appModel.UserModel.Modules[moduleIndex].Pages) {
        pages.push(...this.appModel.UserModel.Modules[moduleIndex].Pages)
      }
    }
    return pages
  }

  get allPages() {
    return [...this.appModule.Pages, ...this.userPages]
  }

  get UserRole() {
    let userRole = !this.isAuthenticated && this.appModel.ProjectSecurity.AllowAnonimousUsers ?
      this.appModel.ProjectSecurity.AnonimousUserRole :
      this.authCore.userRole
    return userRole
  }

  get isAuthenticated()  {
    return this.authCore.isAuthenticated
  }

  getPropFromNavigation(propName) {
    return this.appModel.UserModel?.Navigation?.[propName] ?? this.appModel.Navigation[propName]
  }

  GetSignInPage () {
    let signInPage = this.getPropFromNavigation('SignInPage')
    return this.allPages.find( p => p.$ID === signInPage)
  }

  HaveAccessToPage(page) {
    let signInPage = this.getPropFromNavigation('SignInPage')
    return page?.AllowedRoles.includes(this.UserRole) || page?.$ID === signInPage
  }

  GetHomePage() {
    // определяем домашнюю страницу
    let currentHomePage = this.getPropFromNavigation('HomePage')

    let homePage = this.allPages.find(p => p.$ID === currentHomePage)

    if (this.UserRole) {
      // определяем домашнюю страницу для текущей роли
      let roleBasedHomePage = this.getPropFromNavigation('RoleBasedHomePages')?.[this.UserRole]
      if (!roleBasedHomePage) {
        roleBasedHomePage = this.appModel.Navigation.RoleBasedHomePages?.[this.UserRole]
      }
      if (roleBasedHomePage) {
        homePage = this.allPages.find(p => p.$ID === roleBasedHomePage)
      }
    }
    return homePage
  }

  GoToSignIn() {
    let page = this.GetSignInPage()
    if (page) {
      this.router.push({ name: page.$ID})
    }
  }
  GetPageById(pageId)  {
    return this.allPages.find(p => p.$ID === pageId)
  }

  GoToHomePage() {
    let page = this.GetHomePage()
    if (page) {
      this.router.push({ name: page.$ID })
    }
  }

  RedirectAfterLogin() {
    // Переход по параметрам
    let redirectPageQuery = this.GetPageParams()?.query?.to
    if (redirectPageQuery) {
      this.router.push(redirectPageQuery)
      return
    }
    this.GoToHomePage()
  }

  GetPageParams() {
    const routeData = {
      params: this.router.currentRoute.params,
      query: this.router.currentRoute.query
    }

    if (this.store.state.appRunner.currentPageParams === null) {
      return routeData
    }
    const customParams = JSON.parse(this.store.state.appRunner.currentPageParams)
    routeData.params = this.mergeRouteParams(customParams.params, routeData.params)
    routeData.query = this.mergeRouteParams(customParams.query, routeData.query)
    return routeData
  }

  ClosePage()  {
    // если обычная страница, делаем шаг назад и выходим
    if (this.store.state.appRunner.currentPopPupPageId === null) {
      this.router.go(-1)
      return
    }

    this.store.commit('setCurrentPopPupPage', null)
  }

  mergeRouteParams(source, target) {
    const sourceKeys = Object.keys(source)
    
    if (sourceKeys.length === 0) {
      return target
    }
    
    sourceKeys.forEach(x => {
      target[x] = source[x]
    })
      
    return target
  }
}